export default __webpack_public_path__ + "static/media/m2.b22765fb.webp";